module.exports = __webpack_public_path__ + "static/media/header-phone.c26c0c0f.svg";